{
  "enum": {
    "IxcProspectusV1MediantSegmentStatus": {
      "COMMITTED": "Committed",
      "COMPLETE": "Complete",
      "FAILED": "Failed",
      "NEW": "New",
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcProspectusV1ProspectusJobStatus": {
      "DONE": "Done",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcProspectusV1ProspectusTaskStatus": {
      "COMMITTED": "Committed",
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcProspectusV1TaskUpdatedStatus": {
      "COMMITTED": "Committed",
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcProspectusV1ProspectusJobQueryServiceProspectusJobListFilterableFields": {
      "jobId": "Job ID",
      "status": "Status"
    },
    "IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListFilterableFields": {
      "jobId": "Job ID",
      "status": "Status",
      "taskId": "Task ID"
    }
  },
  "oneOf": {
    "IxcProspectusV1ProspectusJobEventType": {
      "allFinished": "All Finished",
      "created": "Created",
      "taskUpdated": "Task Updated"
    },
    "IxcProspectusV1ProspectusTaskEventType": {
      "committed": "Committed",
      "completed": "Completed",
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed"
    }
  },
  "sortEnum": {
    "IxcProspectusV1ProspectusJobQueryServiceProspectusJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcProspectusV1ProspectusTaskQueryServiceProspectusTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}